import React from "react";
import AudioIconOff from "./header/AudioIconOff.js";
import AudioIconOn from "./header/AudioIconOn.js";

class AudioToggle extends React.Component {
  constructor() {
    super();
    /* this.toggleNav = this.toggleNav.bind(this);*/
    this.state = { iconMuteOn: true };

    // This binding is necessary to make `this` work in the callback
    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    /* console.log(this); */
    console.log("AudioToggle: toggle");

    this.setState(previousState => {
      var vid = $("#custom-header-video")[0];
      if (vid) {
        if (previousState.iconMuteOn) {
          vid.muted = false;
        } else {
          vid.muted = true;
        }
      }
      return { iconMuteOn: !previousState.iconMuteOn };
    });
  }

  render() {
    if (this.state.iconMuteOn) {
      var out = <AudioIconOff />;
    } else {
      var out = <AudioIconOn />;
    }

    return <div onClick={this.toggle}>{out}</div>;
  }
}

export default AudioToggle;
